import { CatalogFeature } from "@/types/catalog-feature";

function limitToDisplay(limit: unknown): string | null {
  if (limit === null) {
    return null;
  }
  if (typeof limit === "number" && Number.isFinite(limit)) {
    return String(limit);
  }
  if (typeof limit === "string") {
    const trimmed = limit.trim();
    if (trimmed === "") {
      return null;
    }
    const n = Number(trimmed);
    if (Number.isFinite(n)) {
      return String(n);
    }
    return trimmed;
  }
  return null;
}

export function featureBadgeDisplayLabel(
  featureId: string,
  meta: CatalogFeature | undefined,
  featureValueById: Readonly<Partial<Record<string, string>>> | undefined,
): string {
  const base = meta?.title ?? featureId;
  if (meta?.type !== "NUMBER") {
    return base;
  }
  const explicit = featureValueById?.[featureId];
  if (explicit !== undefined && explicit.trim() !== "") {
    return `${base} (${explicit.trim()})`;
  }
  const fromLimit = limitToDisplay(meta.limit);
  if (fromLimit !== null) {
    return `${base} (${fromLimit})`;
  }
  return base;
}
